import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Header, Icon } from 'semantic-ui-react';
import { getErrors } from 'shared/lib/geterrors';
import _ from 'lodash';

// Components
import { mapToInitialValues } from './Base/initialValues';
import validateForm from './Base/validation';
import ImpresaBaseForm from './Base/form';
import ImpresaService from '../../../shared/services/api/impresa';

class ImpresaForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  impresaSubmit = (values, { setSubmitting, setValues, setErrors }) => {
    const payload = {
      ...values,
      dataErogazione: values.dataErogazione ? +values.dataErogazione.format('X') : null,
    };

    delete payload.id;

    ImpresaService.patchImpresa(payload, this.props.impresaId)
      .then((response) => {
        // Update formik
        setValues(mapToInitialValues(response));
        setSubmitting(false);

        // Show notification
        this.props.notification().addNotification({
          message: 'Impresa aggiornata con successo',
          level: 'success',
        });
      })
      .catch((error) => {
        // Update formik
        setSubmitting(false);
        setErrors(getErrors(error));

        // Show notification
        this.props.notification().addNotification({
          message:
            _.get(error, 'data.detail') && _.get(error, 'data.detail') !== 'Validazione fallita'
              ? error.data.detail
              : 'Si è verificato un problema con il salvataggio, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  };

  render() {
    const { history, impresa, auth, readOnly, anagraficaName, updateImpresa } = this.props;

    return (
      <Grid style={{ padding: '0px 10px', marginTop: '16px' }}>
        <Grid.Column width="16">
          <Header as="h2">
            <Icon name="id building" />
            <Header.Content>Dati impresa</Header.Content>
          </Header>
        </Grid.Column>

        <Grid.Column width={16}>
          <Formik
            enableReinitialize
            initialValues={mapToInitialValues(impresa || {})}
            validate={validateForm}
            onSubmit={this.impresaSubmit}
            render={(props) => (
              <ImpresaBaseForm
                {...{
                  ...props,
                  history,
                  auth,
                  readOnly,
                  anagraficaName,
                  updateImpresa,
                }}
                isAperta={impresa && impresa.stato === 'aperta'}
              />
            )}
          />
        </Grid.Column>
      </Grid>
    );
  }
}

ImpresaForm.propTypes = {
  /** Current impresa Id, can be 'new' for a not already save one */
  impresaId: PropTypes.string.isRequired,
  /** impresa form intial values*/
  impresa: PropTypes.object,
  /** Used for manage history of the browser -> redirect */
  history: PropTypes.object,
  /** Function for call the notification system */
  notification: PropTypes.func,
  /** Object with data of logged user */
  auth: PropTypes.object,
  /** Read-only fields */
  readOnly: PropTypes.bool,
  /** anagrafica name field */
  anagraficaName: PropTypes.string,
  /** Function tu update datas of istituto */
  updateImpresa: PropTypes.func,
};

export default ImpresaForm;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaForm/index.js